'use client';

import { LoadingOverlay as SharedLoadingOverlay } from '@up2stay/up2promo-ui';
import { useAppState } from '@up2promo-setup-frontend/core/store/app-state.store';
import { useEffect, useState } from 'react';

export default function LoadingOverlay() {
  const appState = useAppState();
  const [debouncedSpinner, setDebouncedSpinner] = useState(appState.spinner);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSpinner(appState.spinner), 250);

    return () => {
      clearTimeout(timer);
    };
  }, [appState.spinner]);

  return (
    <SharedLoadingOverlay
      open={debouncedSpinner}
      logoSrc="/assets/images/brand/logo-white.svg"
      onExitComplete={() => {
        appState.setReady();
      }}
    />
  );
}
